import React from "react";
import { Box, Typography } from "@material-ui/core";
import InfoIcon from "@material-ui/icons/Info";
import FormSection from "./FormSection";
import StatusChip from "./StatusChip";
import useAssistedAffiliationStyles from "../styles";

type RequestSummaryProps = {
  id?: string;
  rows: Array<[string, string]>;
};

const RequestSummary = ({ id, rows }: RequestSummaryProps) => {
  const classes = useAssistedAffiliationStyles();

  return (
    <FormSection id={id} title="Resumen de la solicitud">
      <Box className={classes.summaryList}>
        {rows.map(([label, value]) => (
          <Box className={classes.summaryItem} key={label}>
            <Typography className={classes.summaryLabel}>{label}</Typography>
            {label === "Estado actual" && value !== "-" ? (
              <StatusChip label={value} />
            ) : (
              <Typography className={classes.summaryValue}>{value}</Typography>
            )}
          </Box>
        ))}
      </Box>
      <Box className={classes.infoBox}>
        <InfoIcon fontSize="small" />
        <Typography variant="body2">
          Recuerda ejecutar las validaciones antes de crear el comercio.
        </Typography>
      </Box>
    </FormSection>
  );
};

export default RequestSummary;
